module.exports = __webpack_public_path__ + "static/media/file.9b7711e8.svg";